<div class="text-center">
  <p>Veuillez patienter...</p>
  <p>Vos informations sont en cours de traitement.</p>
</div>